import type { ButtonVariant } from '@/components/button/Button.vue';
import {
  CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION,
  type CorporateOnboardingCareNearYouAction,
} from './types/careNearYouConstants';
import { CORPORATE_ONBOARDING_GUIDED_SELECTION, type CorporateOnboardingGuidedSelectionOption } from './types/selectionConstants';

export interface CareNearYouButtonConfig {
  label: string;
  variant: ButtonVariant;
  action: CorporateOnboardingCareNearYouAction;
}

export interface CareNearYouSecondarySectionConfig {
  description: string;
  button: CareNearYouButtonConfig;
}

export interface CareNearYouConfig {
  description: string;
  primaryButton: CareNearYouButtonConfig;
  secondarySection?: CareNearYouSecondarySectionConfig;
}

export const CARE_NEAR_YOU_CONFIGS: Record<CorporateOnboardingGuidedSelectionOption, CareNearYouConfig> = {
  [CORPORATE_ONBOARDING_GUIDED_SELECTION.JOB_POST]: {
    description: 'The fastest way to find care is to share your needs and get responses from sitters.',
    primaryButton: {
      label: 'Continue',
      variant: 'primary',
      action: CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION.CONTINUE,
    },
  },
  [CORPORATE_ONBOARDING_GUIDED_SELECTION.SEARCH]: {
    description: 'Browse sitters in your area to see who might be a good fit.',
    primaryButton: {
      label: 'Browse sitters Now',
      variant: 'primary',
      action: CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION.BROWSE_SITTERS,
    },
    secondarySection: {
      description: "Share your family's needs for faster,\npersonalized matches.",
      button: {
        label: 'Share your needs',
        variant: 'outlined',
        action: CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION.SHARE_NEEDS,
      },
    },
  },
};

export function getCareNearYouConfig(selection: CorporateOnboardingGuidedSelectionOption | null | undefined): CareNearYouConfig {
  if (selection && selection in CARE_NEAR_YOU_CONFIGS) {
    return CARE_NEAR_YOU_CONFIGS[selection];
  }

  return CARE_NEAR_YOU_CONFIGS[CORPORATE_ONBOARDING_GUIDED_SELECTION.JOB_POST];
}
